import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { NoteForm } from '../generic-notes/NoteForm';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { ICaremapNote } from '../model/NotesClient';
import { NewNoteFormViewModel } from './NewNoteFormViewModel';

interface IActiveCaremapNoteCreatorProps {
    noteVM: NewNoteFormViewModel;
    hasPrivateCheckbox?: boolean;
    autoOpenFileChooser?: boolean;
    includeTemplates?: boolean;
    focusLocation?: number;
    templateSelected?: (label: string) => void;
}

export const ActiveCaremapNoteCreator: React.FC<IActiveCaremapNoteCreatorProps> = ({
    noteVM,
    hasPrivateCheckbox = true,
    autoOpenFileChooser = false,
    includeTemplates = false,
    focusLocation,
    templateSelected
}) => {
    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const notesFactory = useInstance(CaremapNotesModelFactory);
    useSubscription(() => notesFactory);

    return (
        <NoteForm
            isAdd
            canEdit
            hasTitle
            note={noteVM.getNote()}
            cursorLocation={focusLocation}
            includeTemplates={includeTemplates}
            hasPrivateCheckbox={hasPrivateCheckbox}
            autoOpenFileChooser={autoOpenFileChooser}
            noteTarget={noteVM.getNote().otherAttributes.noteTarget}

            // cannot delete while creating
            canDelete={false}

            addAttachmentRequiresInnerhivePlus={noteVM.addAttachmentRequiresInnerhivePlus}
            noteChanged={(updatedNote, templateLabel?) => {
                if (templateSelected && templateLabel) {
                    templateSelected(templateLabel);
                }
                noteVM.setNote(updatedNote as ICaremapNote);
            }}
        />
    );
};
